import { render } from "./EventviewHeaderMatchTeams.vue?vue&type=template&id=19500a9c"
import script from "./EventviewHeaderMatchTeams.vue?vue&type=script&lang=js"
export * from "./EventviewHeaderMatchTeams.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__